import React, { useState } from "react";

import Button from "@mui/material/Button";

import { makeStyles } from "@mui/styles"; // Mise à jour ici
import { useTheme } from "@mui/material";

const useStyles = makeStyles({
  root: {},
  img: {
    maxHeight: 120,
  },
});

const UploadImage = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  const { onFileChange } = props;

  const [previewImage, setPreviewImage] = useState(null);

  const handlePreviewImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      function () {
        setPreviewImage(reader.result);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
      onFileChange(e);
    }
  };

  return (
    <React.Fragment>
      <input
        accept="image/*"
        style={{ margin: "20px 0 20px 0", display: "none" }}
        id="raised-button-file"
        multiple
        type="file"
        onChange={handlePreviewImage}
      />
      <label htmlFor="raised-button-file">
        <Button variant="contained" component="span">
          Ajouter une image
        </Button>
      </label>
      {previewImage && (
        <div>
          <img
            alt="any illustration"
            src={previewImage}
            className={classes.img}
            style={{
              marginTop: theme.spacing(4),
              marginBottom: theme.spacing(4),
            }}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default UploadImage;
